"use client";

import { lazy, Suspense, useCallback, useEffect, useState } from "react";
import type { ChatInterfaceRef } from "@/components/ChatInterface";
import { cn } from "@/lib/utils";
import { useWilsonBarState } from "@/stores/desktopStore";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { WILSON_BAR } from "./wilsonBar.constants";
import { useIsPhone } from "@/hooks/useIsPhone";
import { WilsonLoader } from "@/components/WilsonLoader";
import { Dialog } from "./ui";
const ChatInterface = lazy(() => import("@/components/ChatInterface").then(mod => ({
  default: mod.ChatInterface
})));
export function WilsonBar() {
  const isPhone = useIsPhone();
  const {
    isWilsonBarOpen,
    wilsonBarPrefill,
    setWilsonBarOpen
  } = useWilsonBarState();
  const tA11y = useClientTranslations("desktop.a11y");
  const tChat = useClientTranslations("chat");
  const collapse = useCallback(() => {
    setWilsonBarOpen(false);
  }, [setWilsonBarOpen]);
  const [chat, setChat] = useState<ChatInterfaceRef | null>(null);
  const [hasOpened, setHasOpened] = useState(isWilsonBarOpen);
  if (isWilsonBarOpen && !hasOpened) {
    setHasOpened(true);
  }
  useEffect(() => {
    if (isWilsonBarOpen && chat) {
      const timer = setTimeout(() => {
        chat.scrollToBottom();
        chat.focusInput();
      }, WILSON_BAR.FOCUS_DELAY_MS);
      return () => clearTimeout(timer);
    }
  }, [isWilsonBarOpen, chat]);
  return <Dialog isOpen={isWilsonBarOpen} onClose={collapse} title={tA11y("wilsonBarPanel")} isBare shouldKeepMounted={hasOpened} overlayStyle={{
    zIndex: WILSON_BAR.SCRIM_Z_INDEX
  }} style={{
    zIndex: WILSON_BAR.Z_INDEX,
    top: WILSON_BAR.TOP_OFFSET,
    width: WILSON_BAR.WIDTH,
    height: WILSON_BAR.HEIGHT
  }} className={cn("left-1/2 -translate-x-1/2 rounded-2xl", "bg-surface/20 backdrop-blur-[20px]", "border border-[var(--glass-border)] shadow-glass", "duration-slow ease-in-out motion-safe:data-[state=open]:animate-in motion-safe:data-[state=open]:fade-in-0 motion-safe:data-[state=open]:slide-in-from-bottom-4 motion-safe:data-[state=closed]:animate-out motion-safe:data-[state=closed]:fade-out-0 motion-safe:data-[state=closed]:slide-out-to-bottom-4")} data-sentry-element="Dialog" data-sentry-component="WilsonBar" data-sentry-source-file="WilsonBar.tsx">
            {hasOpened && <Suspense fallback={<div className="flex h-96 items-center justify-center">
                            <WilsonLoader size="lg" text={tChat("loadingChats")} />
                        </div>}>
                    <ChatInterface ref={setChat} isMobile={isPhone} suggestedPrompts={[]} isSpotlightMode prefillMessage={wilsonBarPrefill} />
                </Suspense>}
        </Dialog>;
}